import styled from 'styled-components'

import { Maybe } from '../../../graphql/gatsby'

export const Container = styled.div<{
  backgroundColor?: Maybe<string>
  textColor?: Maybe<string>
  textPosition?: Maybe<string>
}>`
  display: flex;
  flex-direction: column;
  align-items: ${({ textPosition }) =>
    textPosition === 'center' ? 'center' : textPosition === 'right' ? 'flex-end' : 'flex-start'};
  padding: 80px 2.25rem;
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor ?? theme.colors.coolGray.cool150};
  color: ${({ theme, textColor }) => textColor ?? theme.colors.text.primary};

  @media (min-width: 768px) {
    padding-left: 4.5rem;
    padding-right: 4.5rem;
  }

  @media (min-width: 992px) {
    padding: 100px 5.5rem;
  }

  & > div {
    display: flex;
    flex-direction: column;
    max-width: 700px;
    text-align: ${({ textPosition }) => textPosition ?? 'left'};
    align-items: ${({ textPosition }) =>
      textPosition === 'center' ? 'center' : textPosition === 'right' ? 'flex-end' : 'flex-start'};
  }
`
